
<nav class="home-btn circle-line" matRipple>
	<a class="" routerLink="/uvod" routerLinkActive="active" title="přejít na úvodní stránku">
		<app-icon class="logo" name="logo_thin"></app-icon>
	</a>
</nav> 

<nav class="back-btn" 
[class.disabled]="(showBackButton$ | push) === false"

>
	<app-back-btn 
		class="detail-back-btn" 
		[currentTaxonomyPage$]="currentTaxonomyPage$"
		[route$]="route$"
	></app-back-btn>
</nav>



<nav 
	class="main-navigation-wrapper"
	[@navigationAnimation]="(hideNav$ | push) ? 'up' : 'down'"
>
	<ul class="main-navigation" >
	  <li class="main-section" *ngFor="let route of (routes$ | push)" (mouseenter)="mouseEvent(route, 'open')" (mouseleave)="mouseEvent(route, 'closed')" >
	    <app-route-link 
	    	class="section-route-link" 
	    	[route]="route" 
	    ></app-route-link>
	    <ul class="main-routes" [@mainRoutesAnimation]="(navigationState$ | push).url === route.url ? (navigationState$ | push).state : 'closed'" >
      <li class="main-route" *ngFor="let subPage of route.children" (click)="mouseEvent(route, 'closed')" >
	      	<app-route-link class="main-route-link" [route]="subPage" >
	      	</app-route-link>
	      </li>
	    </ul>
	  </li>
	</ul>
</nav>

<span class="navigation-shadow"></span>


<nav class="side-nav">
	<span class="gradient-side-nav"></span>
	<a 
		class="search-btn circle-line"
		[routerLink]="['/hledat']" 
		routerLinkActive="active"
		matRipple
		title="vyhledávání obsahu"
		>
		<app-icon class="search-icon" name="search"></app-icon>
	</a>
	<!-- <app-user-badge class="user-btn circle-line"></app-user-badge> -->
	<a 
		title="{{(navigationOpen$ | push) ? 'Zavřít navigaci' : 'Otevřít navigaci'}}"
		class="mobile-btn" 
		[routerLink]="[getRoute(navigationOpen$ | push)]" 
		queryParamsHandling="preserve"
		[skipLocationChange]="true" 
		[@mobileBtnAnimation]="(hideNav$ | push) ? 'show' : 'hide'"
	>
		<span class="burger circle-line" matRipple>
			<app-icon-close class="menu-burger" icon="menu" [buttonActive]="(navigationOpen$ | push)" ></app-icon-close>
			<app-icon-close class="menu-mini" icon="menu_mini" [buttonActive]="(navigationOpen$ | push)" ></app-icon-close>
		</span>
	</a>
</nav>

